/* FICHIER GÉNÉRÉ par `pnpm tokens` depuis src/styles/tokens.json.
 * Ne rien écrire ici : la CI regénère palette.ts et compare (06 §11).
 */

export const THEMES_TOKENS = {
  "light": {
    "label": "Clair",
    "colorScheme": "light",
    "fond": "#FFFFFF",
    "surface-2": "#F7F9F9",
    "texte-1": "#0F1419",
    "texte-2": "#536471",
    "bordure": "#CFD9DE",
    "bordure-champ": "#8F9699",
    "etats": {
      "juste": "#00A971",
      "faux": "#F4212E",
      "attente": "#B09200",
      "notion": "#7856FF",
      "demarche": "#00A3A3"
    },
    "surfaces": {
      "juste": {
        "fond": "#008659",
        "encre": "#FFFFFF"
      },
      "faux": {
        "fond": "#E81F2C",
        "encre": "#FFFFFF"
      },
      "attente": {
        "fond": "#FFD400",
        "encre": "#000000"
      },
      "notion": {
        "fond": "#7856FF",
        "encre": "#FFFFFF"
      },
      "demarche": {
        "fond": "#008484",
        "encre": "#FFFFFF"
      }
    }
  },
  "dim": {
    "label": "Sombre",
    "colorScheme": "dark",
    "fond": "#15202B",
    "surface-2": "#1E2732",
    "texte-1": "#F7F9F9",
    "texte-2": "#8B98A5",
    "bordure": "#495A64",
    "bordure-champ": "#5D6C75",
    "etats": {
      "juste": "#00BA7C",
      "faux": "#F4212E",
      "attente": "#FFD400",
      "notion": "#7856FF",
      "demarche": "#00A3A3"
    },
    "surfaces": {
      "juste": {
        "fond": "#008659",
        "encre": "#FFFFFF"
      },
      "faux": {
        "fond": "#E81F2C",
        "encre": "#FFFFFF"
      },
      "attente": {
        "fond": "#FFD400",
        "encre": "#000000"
      },
      "notion": {
        "fond": "#7856FF",
        "encre": "#FFFFFF"
      },
      "demarche": {
        "fond": "#008484",
        "encre": "#FFFFFF"
      }
    }
  },
  "lights-out": {
    "label": "Noir",
    "colorScheme": "dark",
    "fond": "#000000",
    "surface-2": "#16181C",
    "texte-1": "#E7E9EA",
    "$comment-texte-2": "#71767B — la valeur de Twitter — ne donne que 3,88:1 sur le fond noir et 3,5:1 sur --surface-2. Éclairci jusqu'au seuil : ce gris porte les aides de saisie et les compteurs, c'est du texte (RG-D1).",
    "texte-2": "#8A8F94",
    "bordure": "#3E4447",
    "bordure-champ": "#555A5D",
    "etats": {
      "juste": "#00BA7C",
      "faux": "#F4212E",
      "attente": "#FFD400",
      "notion": "#7856FF",
      "demarche": "#00A3A3"
    },
    "surfaces": {
      "juste": {
        "fond": "#008659",
        "encre": "#FFFFFF"
      },
      "faux": {
        "fond": "#E81F2C",
        "encre": "#FFFFFF"
      },
      "attente": {
        "fond": "#FFD400",
        "encre": "#000000"
      },
      "notion": {
        "fond": "#7856FF",
        "encre": "#FFFFFF"
      },
      "demarche": {
        "fond": "#008484",
        "encre": "#FFFFFF"
      }
    }
  }
} as const

export const ACCENTS_TOKENS = {
  "light": {
    "bleu": {
      "base": "#1A8CD8",
      "vif": "#1A8CD8",
      "fort": "#177BBE",
      "encre": "#FFFFFF"
    },
    "violet": {
      "base": "#7856FF",
      "vif": "#7856FF",
      "fort": "#7856FF",
      "encre": "#FFFFFF"
    },
    "rose": {
      "base": "#F91880",
      "vif": "#F91880",
      "fort": "#E31674",
      "encre": "#FFFFFF"
    },
    "orange": {
      "base": "#FF7A00",
      "vif": "#ED7100",
      "fort": "#BD5A00",
      "encre": "#FFFFFF"
    },
    "vert": {
      "base": "#00BA7C",
      "vif": "#00A971",
      "fort": "#008659",
      "encre": "#FFFFFF"
    },
    "jaune": {
      "base": "#FFD400",
      "vif": "#B09200",
      "fort": "#FFD400",
      "encre": "#000000"
    }
  },
  "dim": {
    "bleu": {
      "base": "#1A8CD8",
      "vif": "#1A8CD8",
      "fort": "#177BBE",
      "encre": "#FFFFFF"
    },
    "violet": {
      "base": "#7856FF",
      "vif": "#7856FF",
      "fort": "#7856FF",
      "encre": "#FFFFFF"
    },
    "rose": {
      "base": "#F91880",
      "vif": "#F91880",
      "fort": "#E31674",
      "encre": "#FFFFFF"
    },
    "orange": {
      "base": "#FF7A00",
      "vif": "#FF7A00",
      "fort": "#BD5A00",
      "encre": "#FFFFFF"
    },
    "vert": {
      "base": "#00BA7C",
      "vif": "#00BA7C",
      "fort": "#008659",
      "encre": "#FFFFFF"
    },
    "jaune": {
      "base": "#FFD400",
      "vif": "#FFD400",
      "fort": "#FFD400",
      "encre": "#000000"
    }
  },
  "lights-out": {
    "bleu": {
      "base": "#1A8CD8",
      "vif": "#1A8CD8",
      "fort": "#177BBE",
      "encre": "#FFFFFF"
    },
    "violet": {
      "base": "#7856FF",
      "vif": "#7856FF",
      "fort": "#7856FF",
      "encre": "#FFFFFF"
    },
    "rose": {
      "base": "#F91880",
      "vif": "#F91880",
      "fort": "#E31674",
      "encre": "#FFFFFF"
    },
    "orange": {
      "base": "#FF7A00",
      "vif": "#FF7A00",
      "fort": "#BD5A00",
      "encre": "#FFFFFF"
    },
    "vert": {
      "base": "#00BA7C",
      "vif": "#00BA7C",
      "fort": "#008659",
      "encre": "#FFFFFF"
    },
    "jaune": {
      "base": "#FFD400",
      "vif": "#FFD400",
      "fort": "#FFD400",
      "encre": "#000000"
    }
  }
} as const

/** Les noms d’accent, dans l’ordre du sélecteur. */
export const NOMS_ACCENTS = ["bleu","violet","rose","orange","vert","jaune"] as const
